import m from 'mithril';
import { HomePage } from './pages/HomePage';
import { ProductDetailPage } from './pages/ProductDetailPage';
import { CartPage } from './pages/CartPage';
import { CheckoutPage } from './pages/CheckoutPage';
import { AdminDashboard } from './pages/AdminDashboard';
import { ProfilePage } from './pages/ProfilePage';
import { Store } from './store';
import { ApiService } from './services/api';
import { AuthModal } from './components/AuthModal';
import { SideMenu } from './components/SideMenu';
import { Button } from './components/Buttons';
import { ToastContainer } from './components/Toasts';
import { SlideOutCart } from './components/SlideOutCart';

import { UserProfileMenu } from './components/UserProfileMenu';
import { LiveSearch } from './components/LiveSearch';

import { t, currentLang, setLanguage } from './i18n';
import { currentTheme, setTheme, Theme } from './theme';

import { Header } from './components/Header';
import { Footer } from './components/Footer';

const Layout: m.Component<{ children: m.Children }> = {
    view(vnode) {
        return m('div', { 
            class: `h-[100dvh] overflow-hidden flex flex-col transition-colors duration-500 text-[var(--color-text-base)] ${currentLang === 'ar' ? 'font-arabic' : ''}`, 
            dir: currentLang === 'ar' ? 'rtl' : 'ltr',
            style: currentLang === 'ar' ? undefined : 'font-family: var(--dynamic-font, inherit);'
        }, [
            m(ToastContainer),
            m(AuthModal),
            m(SlideOutCart),
            m(Header),
            m(SideMenu),
            m('main', {
                class: 'flex-1 overflow-y-auto overflow-x-hidden pt-14 relative',
                style: `padding-left: ${typeof window !== 'undefined' && window.innerWidth >= 1024
                    ? (Store.state.sidebarCollapsed ? '60px' : '220px')
                    : '0px'}; transition: padding-left 300ms cubic-bezier(0.4,0,0.2,1)`,
            }, [
                m('div', { class: 'px-4 sm:px-6 py-6 animate-fade-in-up min-h-full flex flex-col' }, [
                    vnode.attrs.children,
                    // Insert full Footer
                    m(Footer)
                ])
            ])
        ]);
    }
};

const routeMap = {
    '/':            { title: 'KHALID | Premium Medical & Child Care', comp: HomePage },
    '/product/:id': { title: 'KHALID | Product Details',              comp: ProductDetailPage },
    '/cart':        { title: 'KHALID | Shopping Cart',                comp: CartPage },
    '/checkout':    { title: 'KHALID | Secure Checkout',              comp: CheckoutPage },
    '/profile':     { title: 'KHALID | My Account',                   comp: ProfilePage }
};

export const routes = Object.fromEntries(
    Object.entries(routeMap).map(([path, { title, comp }]) => [
        path, {
            onmatch: () => {
                document.title = title;
                return { view: () => m(Layout, { children: m(comp) }) };
            }
        }
    ])
);

